import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal__title"
}
const _hoisted_2 = {
  key: 1,
  class: "modal__body"
}
const _hoisted_3 = {
  key: 2,
  class: "modal__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTimes = _resolveComponent("IconTimes")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#visible-screen-40" }, [
    _createElementVNode("div", {
      class: "modal__page-mask",
      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["stop"]))
    }, [
      _createElementVNode("section", {
        class: "modal",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn btn-tertiary btn-sm modal__btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["esc"]))
        }, [
          _createVNode(_component_IconBase, null, {
            default: _withCtx(() => [
              _createVNode(_component_IconTimes)
            ]),
            _: 1
          })
        ], 32)), [
          [_directive_focus],
          [_directive_ripple]
        ]),
        (_ctx.slots.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [
              _renderSlot(_ctx.$slots, "title")
            ]))
          : _createCommentVNode("", true),
        (_ctx.slots.body)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "body")
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.slots.footer || _ctx.closeBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "footer"),
              (_ctx.closeBtn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["btn btn-m", `btn-${_ctx.closeBtn.variant}`]),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.closeBtn.text), 3))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}